import { handleActions } from 'redux-actions'
import lodash from 'lodash'
import update from 'immutability-helper'
import uuidv4 from 'uuid/v4'
import { STEPPER_MAX } from '../../constants/app'

const _ = lodash

const defaultBasketState = {}
const defaultOrderState = []
const defaultStashState = {}

export const stash = handleActions({
  ADD_STASH: (state, action) => {
    return action.payload
  },
  UPDATE_STASH: (state, action) => {
    const _array = []
    if (!lodash.isEmpty(action.payload)) {
      lodash.forEach(action.payload, (item) => {
        lodash.forEach(item.options, (option) => {
          _array.push(option)
        })
      })
    }

    const nextState = update(state, {
      options: {
        $merge: _array,
      },
    })

    return nextState
  },
  RESET_STASH: (state, action) => {
    state = defaultStashState
    return state
  },
}, defaultStashState)

export const orders = handleActions({
  ADD_ORDER: (state, action) => {
    const item = action.payload
    const isModifyByNumberPad = item.isModifyByNumberPad
    delete item.isModifyByNumberPad

    // if the item is a set
    if (item.setStep) {
      return handleAddOrderOnSet(item, state, action, isModifyByNumberPad)
    }

    if (!lodash.isEmpty(state)) {
      return handleAddOrderOnInitializedState(item, state, action, isModifyByNumberPad)
    } else {
      return handleAddOrderOnUnitializedState(item, state, action, isModifyByNumberPad)
    }
  },
  UPDATE_ORDER: (state, action) => {
    if (!lodash.isEmpty(action.payload)) {
      const _options = []
      let _dishId = ''

      lodash.forEach(action.payload, function (group) {
        _dishId = group.dishId
        _options.push(group.options.filter((opt) => !!opt.id))
      })

      const group = [].concat.apply([], _options)

      const _filter = lodash.filter(state, function (result) {
        return result.dishId === _dishId
      })

      if (_filter.length !== 0) {
        const _newData = _filter.map(item => {
          const _data = update(item, {
            options: {
              [item.options.length - 1]: {
                $merge: group,
              },
            },
          })
          return _data
        })

        const stashIndex = lodash.findIndex(state, function (findResult) {
          return findResult.dishId === _newData[0].dishId
        })

        const _nextState = update(state, {
          [stashIndex]: {
            options: {
              [state[stashIndex].options.length - 1]: {
                $merge: _newData[0].options[state[stashIndex].options.length - 1],
              },
            },
          },
        })

        return _nextState
      }
    } else {
      return state
    }
  },
  UPDATE_ORDER_REMARK: (state, action) => {
    return update(state, {
      remark: {
        $set: action.payload.remark,
      },
    })
  },
  UPDATE_SET_ORDER_CONFIRMED_STATUS: (state, action) => {
    const index = lodash.findIndex(state, (order) => {
      return (order.dishId === action.payload.catId) && !_.get(order, 'confirmed')
    })
    return update(state, {
      [index]: {
        confirmed: { $set: _.get(action, 'payload.confirmed', false) },
      },
    })
  },
  CANCEL_ORDER: (state, action) => {
    const stashIndex = lodash.findIndex(state, function (findResult) {
      return findResult.dishId === action.payload.dishId
    })

    let newState = ''
    const lengthOfGroupOptions = state[stashIndex].options.length

    if (lengthOfGroupOptions <= 1) {
      newState = update(state, {
        $splice: [
          [stashIndex, 1],
        ],
      })
    } else {
      newState = update(state, {
        [stashIndex]: {
          total: {
            $set: action.payload.total - action.payload.price,
          },
          quantity: {
            $set: action.payload.quantity - 1,
          },
          options: {
            $splice: [
              [lengthOfGroupOptions - 1, 1],
            ],
          },
        },
      })
    }

    return newState
  },
  RESET_ORDER: (state, action) => {
    state = defaultOrderState
    return state
  },
  DELETE_ORDER_BY_DISH_ID: (state, action) => {
    const _index = lodash.findIndex(state, (item) => {
      return item.dishId === action.payload && !item.confirmed
    })
    const newState = update(state, { $splice: [[_index, 1]] })
    return newState
  },
  UPDATE_PER_ITEM_REMARK: (state, action) => {
    if (action.payload.isSet) {
      const {
        orderIndex,
        itemIndex,
        remarks,
      } = action.payload

      const newRemarks = [[...state[orderIndex].items[itemIndex].remarks[0], ...remarks]]

      return update(state, {
        [orderIndex]: {
          items: {
            [itemIndex]: {
              remarks: { $set: newRemarks },
            },
          },
        },
      })
    } else {
      const { orderIndex, selectedRemarkIndex, remarks } = action.payload
      const orderItem = state[orderIndex]

      // const index = lodash.findIndex(state, (order) => {
      //     if (order.dishId === action.payload.dishId) {
      //         item = order;
      //         return true;
      //     }
      // });
      // find the index of remark array by
      // checking the items inside the array

      let oldRemarks
      if (orderItem.remarks) {
        oldRemarks = JSON.parse(JSON.stringify(orderItem.remarks))
      } else {
        oldRemarks = []
      }

      if (oldRemarks[selectedRemarkIndex]) {
        oldRemarks[selectedRemarkIndex] = remarks
      } else {
        oldRemarks.push(remarks)
      }

      return update(state, {
        [orderIndex]: {
          remarks: { $set: oldRemarks },
        },
      })
    }
  },
  REMOVE_PER_ITEM_REMARK: (state, action) => {
    const index = action.payload.orderIdx
    const item = state[index]
    // const index = lodash.findIndex(state, (order) => {
    //     if (order.dishId === action.payload.dishId) {
    //         item = order;
    //         return true;
    //     }
    // });

    const { isSetItem, subItemIndex } = action.payload
    if (!isSetItem) { // 單點
      const selectedItemIdex = action.payload.selectedItemIdex
      if (item && item.remarks && item.remarks[selectedItemIdex]) {
        const remarks = JSON.parse(JSON.stringify(item.remarks[selectedItemIdex]))
        const objIndex = remarks.indexOf(action.payload.remark)
        if (objIndex > -1) {
          remarks.splice(objIndex, 1)
          const tmp = JSON.parse(JSON.stringify(item.remarks))
          tmp[selectedItemIdex] = remarks
          return update(state, {
            [index]: {
              remarks: { $set: tmp },
            },
          })
        } else {
          return state
        }
      } else {
        return state
      }
    } else { // 套餐
      const subItem = item.items[subItemIndex]
      const newRemarks = subItem.remarks[0].filter(remark => remark !== action.payload.remark)
      return update(state, {
        [index]: {
          items: {
            [subItemIndex]: {
              remarks: { $set: [newRemarks] },
            },
          },
        },
      })
    }
  },
}, defaultOrderState)

export const basket = handleActions({
  UPDATE_PROMO_CODE: (state, action) => {
    return update(state, {
      promoCode: { $set: action.payload },
    })
  },
  SET_IS_TAKE_AWAY: (state, action) => {
    return update(state, {
      isTakeaway: {
        $set: action.payload,
      },
    })
  },
  SET_IS_DELIVERY: (state, action) => {
    return update(state, {
      isDelivery: {
        $set: action.payload,
      },
    })
  },
  SET_IS_SHOP: (state, action) => {
    return update(state, {
      isShop: {
        $set: action.payload,
      },
    })
  },
  SET_IS_STORE_DELIVERY: (state, action) => {
    return update(state, {
      isStoreDelivery: {
        $set: action.payload,
      },
    })
  },
  SET_SHIPPING: (state, action) => {
    return update(state, {
      shipping: {
        $set: action.payload,
      },
    })
  },
  SET_CARD_ONLY: (state, action) => {
    return update(state, {
      isCardOnly: {
        $set: action.payload,
      },
    })
  },
  SET_TAKEAWAY_AVAILABLE: (state, action) => {
    return update(state, {
      isTakeawayAvailable: {
        $set: action.payload,
      },
    })
  },

  SET_OUT_TRADE_NO: (state, action) => {
    return update(state, {
      outTradeNo: {
        $set: action.payload,
      },
    })
  },
  SET_DELIVERY_AVAILABLE: (state, action) => {
    return update(state, {
      isDeliveryAvailable: {
        $set: action.payload,
      },
    })
  },
  // show create basket dialog
  REQUEST_CREATE_BASKET: (state, action) => {
    const params = {
      request: {
        $set: true,
      },
    }
    if (action.payload && action.payload.table) {
      params.table = {
        $set: action.payload.table,
      }
    }
    return update(state, params)
  },
  CREATE_BASKET: (state, action) => {
    const order = action.payload

    return update(state, {
      id: {
        $set: order.id,
      },
      uuid: {
        $set: state.uuid ? state.uuid : uuidv4(),
      },
      discount: {
        $set: order.discount ? order.discount : { percent: 0, amount: 0, overrideItem: false },
      },
      merchantId: {
        $set: order.merchantId,
      },
      table: {
        $set: order.table,
      },
      paying: {
        $set: order.paying,
      },
      createdAt: {
        $set: order.createdAt,
      },
      request: {
        $set: false,
      },
      takeawayStatus: {
        $set: order.takeawayStatus,
      },
      takeawayOrders: {
        $set: order.items,
      },
      canPay: {
        $set: order.items ? (order.items.length > 0) : false,
      },
      status: {
        $set: order.status,
      },
      code: {
        $set: order.code ? order.code : '',
      },
    })
  },
  ADD_BASKET: (state, action) => {
    return action.payload
  },
  RESET_BASKET: (state, action) => {
    if (!action.payload) {
      return update(state, {})
    }
    return update(state, {
      uuid: {
        $set: uuidv4(),
      },
    })
  },
  CLEAR_BASKET: (state, action) => {
    return {}
  },
  PAY_ORDER: (state, action) => {
    return update(state, {
      paying: {
        $set: true,
      },
    })
  },
  REQUEST_SERVICE: (state, action) => {
    return update(state, {
      isRequestingService: {
        $set: true,
      },
    })
  },
  SET_FILTERED_BY_ME: (state, action) => {
    return update(state, {
      isFilteredByMe: {
        $set: action.payload,
      },
    })
  },
  SET_TAKEAWAY_ORDERS: (state, action) => {
    return update(state, {
      takeawayOrders: {
        $set: action.payload,
      },
    })
  },
  SET_TAKEAWAY_STATUS: (state, action) => {
    return update(state, {
      takeawayStatus: {
        $set: action.payload,
      },
    })
  },
  UPDATE_CAN_PAY: (state, action) => {
    return update(state, {
      canPay: {
        $set: action.payload,
      },
    })
  },
  SET_TAKEAWAY_DISCOUNT: (state, action) => {
    return update(state, {
      discount: {
        $set: action.payload,
      },
    })
  },
  REDEEM_PROMO_CODE: (state, action) => {
    return update(state, {
      promoCode: {
        $set: action.payload.data.code,
      },
      discount: {
        $set: {
          percent: action.payload.data.percent,
          amount: action.payload.data.amount,
        },
      },
    })
  },
  REMOVE_PROMO_CODE: (state, action) => {
    return update(state, {
      promoCode: {
        $set: null,
      },
      discount: {
        $set: null,
      },
    })
  },
}, defaultBasketState)

export default {
  basket,
  orders,
  stash,
}

const handleAddOrderOnSet = (item, stateOrders, action, isModifyByNumberPad) => {
  let orderIndex = -1
  // order object for transformation
  const order = {
    merchantId: item.merchantId,
    dish: item.category.name,
    dishId: item.category.id,
    steps: item.category.steps,
    items: [],
    options: [],
    remarks: [],
    stepNo: item.stepNo,
  }

  // if state has been initialized
  if (!lodash.isEmpty(stateOrders)) {
    orderIndex = lodash.findIndex(stateOrders, (result) => {
      return (result.dishId === order.dishId) && !result.confirmed
    })

    // if the order has been added before, modify by orderIndex
    if (orderIndex >= 0) {
      const oldOrder = stateOrders[orderIndex]
      order.items = oldOrder.items.slice() // copy items from exiting order item
    }
  }

  const isItemExisted = order.items.some((oldItem, i) => {
    // find item which has the same dish id
    if (oldItem.dishId === item.dishId) {
      if (item.quantity > 0) {
        // item.quantity > 0 can have "ADD" and "SUBTRACT" two cases
        if (item.isIncrement) {
          // it is to "ADD" new order
          order.items[i] = {
            ...oldItem,
            quantity: item.quantity,
            total: item.total,
            options: [
              ...oldItem.options,
              item.options,
            ],
            remarks: [...oldItem.remarks, []],
          }
        } else {
          // it is to "SUBTRACT" existing order
          const _selectOptionIndex = action.meta.selectOptionIndex

          const _orderItem = lodash.find(stateOrders, (i, k) => {
            if (i.steps) {
              return (i.dishId === item.category.id) && !i.confirmed
            } else {
              return (i.dishId === item.category.id)
            }
          })
          const _currentStepItem = lodash.find(_orderItem.items, (i, k) => {
            return i.dishId === item.dishId
          })
          // update item in redux state orders with new options
          const _newOptions = update(_currentStepItem, {
            options: {
              $splice: [[_selectOptionIndex, 1]],
            },
          })

          // udpate item at index i with options of the new order
          order.items[i] = {
            ...oldItem,
            quantity: item.quantity,
            total: item.total,
            options: _newOptions.options,
          }
        }
      } else {
        // it is to "REMOVE" existing order
        // remove item at index i if "new" order has quantity <= 0
        order.items.splice(i, 1)
      }
      // found item with the same dish Id
      return true
    }
    return false
  })

  if (!isItemExisted) {
    // if item does not exist before

    if (item.quantity > 0) {
      if (action.payload.isStepper) {
        order.items.push({
          ...item,
          options: [
            item.options,
          ],
          remarks: [item.remarks],
        })
      } else {
        if (!lodash.isEmpty(stateOrders)) {
          let itemsToBeKept = item

          if (orderIndex !== -1) {
            itemsToBeKept = lodash.filter(stateOrders[orderIndex].items, (item) => {
              return item.setStep.key !== action.payload.setStep.key
            })
          }

          const items = [
            ...itemsToBeKept,
          ]

          items.push({
            ...item,
            options: [
              item.options,
            ],
            remarks: [item.remarks],
          })

          order.items = items
        } else {
          order.items.push({
            ...item,
            options: [
              item.options,
            ],
            remarks: [item.remarks],
          })
        }
      }
    }
  }

  order.items = order.items.filter(item => {
    if (_.get(item, 'setStep.dependsOnSetMenuItem') || (_.get(item, 'setStep.dependsOnSetMenuItems') && item.setStep.dependsOnSetMenuItems.length > 0)) {
      let nextStep = _.get(order, 'items', []).map((i) => i.dishId).includes(item.setStep.dependsOnSetMenuItem)
	    _.get(order, 'items', []).map((i) => i.dishId).some(o => {
	      if (item.setStep.dependsOnSetMenuItems && item.setStep.dependsOnSetMenuItems.includes(o)) {
	        nextStep = true
	        return true
	      }
        return false
	    })
	    return nextStep
    }
    return true
  })

  if (order.items.length > 0) {
    order.quantity = 0

    const stepQuantities = {}
    order.total = order.items.reduce((accu, item) => {
      const q = stepQuantities[item.setStep.key]
      stepQuantities[item.setStep.key] = (q || 0) + item.quantity
      return accu + item.total
    }, 0)

    order.steps.forEach((step) => {
      const q = stepQuantities[step.key]
      if (q) {
        step.quantity = q
        if (step.max > 0) {
          step.setQuantity = q >= step.min && q <= step.max ? 1 : 0
        } else {
          step.setQuantity = q >= step.min ? 1 : 0
        }
        // step.setQuantity = q / (step.ratio ? step.ratio : 1);
        if (order.quantity < step.setQuantity) {
          order.quantity = step.setQuantity
        }
      } else {
        step.quantity = 0
        step.setQuantity = 0
      }
    })
    order.pending = order.steps.some((step) => step.quantity < order.quantity)
  }

  if (orderIndex >= 0) {
    if (order.items.length > 0) {
      return update(stateOrders, {
        [orderIndex]: {
          $set: order,
        },
      })
    } else {
      return update(stateOrders, {
        $splice: [
          [orderIndex, 1],
        ],
      })
    }
  } else {
    if (order.items.length > 0) {
      return update(stateOrders, {
        $push: [order],
      })
    } else {
      return stateOrders
    }
  }
}

const handleAddOrderOnInitializedState = (item, stateOrders, action, isModifyByNumberPad) => {
  // 在 state.orders 中找出目前要變動的餐點
  let stateItems = lodash.filter(stateOrders, (stateOrder) => {
    return stateOrder.dishId === item.dishId
  })

  // fix same set different steps option error
  if (stateItems.length > 1 && lodash.get(item, 'setItems.length')) {
    stateItems = lodash.filter(stateItems, (result) => {
      // compare dishIds in items, for 套餐
      const a = result.items.map(o => o.dishId).sort().join('|')
      const b = item.setItems.map(o => o.dishId).sort().join('|')
      return a === b
    })
  }

  if (action.payload.isIncrement) {
    // Add
    if (stateItems.length !== 0) {
      // append item to arrays
      const orderIndex = lodash.findIndex(stateOrders, (result) => {
        return result.dishId === item.dishId
      })

      if (item.quantity > STEPPER_MAX) {
        return stateOrders
      }
      const _data = stateItems.map(stateItem => {
        return {
          ...stateItem,
          quantity: item.quantity,
          total: item.total,
          options: isModifyByNumberPad
            ? Array(item.quantity).fill(item.options)
            : [
              ...stateItem.options,
              item.options,
            ],
          remarks: isModifyByNumberPad
            ? Array(item.quantity).fill(item.remarks)
            : [...stateItem.remarks, []],
        }
      })
      const nextState = update(stateOrders, {
        [orderIndex]: {
          quantity: {
            $set: _data[0].quantity,
          },
          total: {
            $set: _data[0].total,
          },
          options: {
            $set: _data[0].options,
          },
          remarks: {
            $set: _data[0].remarks,
          },
        },
      })
      return nextState
    } else {
      item.options = isModifyByNumberPad
        ? Array(item.quantity).fill(item.options)
        : [item.options]
      item.remarks = isModifyByNumberPad
        ? Array(item.quantity).fill(item.remarks)
        : [item.remarks]
      const newState = update(stateOrders, {
        $push: [item],
      })
      return newState
    }
  } else {
    // Remove
    if (stateItems.length !== 0) {
      const _data = stateItems.map(stateItem => {
        // const lengthOfGroupOptions = group.options.length - 1;
        const selectOptionIndex = action.meta.selectOptionIndex

        return update(stateItem, {
          total: {
            $set: action.payload.total,
          },
          quantity: {
            $set: action.payload.quantity,
          },
          options: isModifyByNumberPad ? {
            $set: Array(item.quantity).fill(stateItem.options[0]),
          } : {
            $splice: [
              [selectOptionIndex, 1],
            ],
          },
          remarks: isModifyByNumberPad ? {
            $set: Array(item.quantity).fill(stateItem.remarks[0]),
          } : {
            $splice: [
              [selectOptionIndex, 1],
            ],
          },
        })
      })

      const stashIndex = lodash.findIndex(stateOrders, function (findResult) {
        if (lodash.get(findResult, 'items.length') && lodash.get(item, 'setItems.length')) {
          // compare dishIds in items, for 套餐
          const a = findResult.items.map(o => o.dishId).sort().join('|')
          const b = item.setItems.map(o => o.dishId).sort().join('|')
          return a === b
        }
        return findResult.dishId === _data[0].dishId
      })

      let newState = ''

      if (_data[0].quantity > 0) {
        newState = update(stateOrders, {
          [stashIndex]: {
            total: {
              $set: _data[0].total,
            },
            quantity: {
              $set: _data[0].quantity,
            },
            options: {
              $set: _data[0].options,
            },
            remarks: {
              $set: _data[0].remarks,
            },
          },
        })
      } else {
        newState = update(stateOrders, {
          $splice: [
            [stashIndex, 1],
          ],
        })
      }
      return newState
    }
  }
}

const handleAddOrderOnUnitializedState = (item, stateOrders, action, isModifyByNumberPad) => {
  if (isModifyByNumberPad) {
    item.options = Array(item.quantity).fill(item.options)
    item.remarks = Array(item.quantity).fill(item.remarks)
  } else {
    item.options = [item.options]
    item.remarks = [item.remarks]
  }
  return [
    ...stateOrders,
    item,
  ]
}



// WEBPACK FOOTER //
// ./src/reducers/components/basket.js